import { render } from "./SalesLeaderboard.vue?vue&type=template&id=772bd832"
import script from "./SalesLeaderboard.vue?vue&type=script&lang=js"
export * from "./SalesLeaderboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__